import { EnvMicroTreasury } from "lib-klab-core";

const streams: EnvMicroTreasury["streams"] = {
  collector: "/api/v1/wallet-live-view/collector/stream",
  "wallet-recharges": "/api/v1/wallet-live-view/wallet-recharges/stream",
  circulating: "/api/v1/wallet-live-view/circulating/stream",
  general: "/api/v1/wallet-live-view/general/stream",
};

const baseEnvironment: Pick<
  EnvMicroTreasury,
  "reconnectInitialDelayMs" | "reconnectMaxDelayMs" | "streams"
> = {
  reconnectInitialDelayMs: 1_000,
  reconnectMaxDelayMs: 30_000,
  streams,
};

export const envTreasuryLocal: EnvMicroTreasury = {
  ...baseEnvironment,
  host: "",
  apiBasePath: "/ms-treasury",
  enabled: true,
  useMocks: false,
  companyCode: "INCLUB",
  authMode: "none",
};

export const envTreasuryDev: EnvMicroTreasury = {
  ...baseEnvironment,
  host: "https://gatewayapi-dev.erp.inclub.world",
  apiBasePath: "/ms-treasury",
  enabled: true,
  useMocks: false,
  companyCode: "INCLUB_WORLD",
  authMode: "bearer",
};

export const envTreasuryProd: EnvMicroTreasury = {
  ...baseEnvironment,
  host: "",
  apiBasePath: "/ms-treasury",
  enabled: false,
  useMocks: false,
  companyCode: "INCLUB",
  authMode: "none",
};
